module.exports = __webpack_public_path__ + "cd4e92651a591218c6d687faf9d541b0.MP3";